<template>
    <div class="addBox">
        <el-form ref="form" :model="templateForm" label-width="80px" :rules="rules">
            <el-form-item label="模板名称" style="width: 350px" prop="name">
                <el-input v-model="templateForm.name"></el-input>
            </el-form-item>
        </el-form>
        <el-button @click="addBtn" type="primary" plain style="margin-left:80px;">新增模板</el-button>
        <el-button @click="verifyAdd" type="primary">确认新增</el-button>
        <el-drawer
                title="我是标题"
                :visible.sync="drawer"
                :with-header="false"
                :before-close="handleClose"
                size="60%">
            <div class="bigBox">
                <div class="leftBox">
                    <el-tabs v-model="activeName" @tab-click="handleClick">
                        <!--                        系统费默认字段列表-->
                        <el-tab-pane label="系统字段" name="first">
                            <div>
                                <el-input
                                        placeholder="搜索内容"
                                        v-model="searchQuery"
                                />
                                <el-checkbox-group v-model="selectedNames">
                                    <div>
                                        <el-checkbox
                                                v-for="fields in filteredfields"
                                                :key="fields.key"
                                                :label="fields.label"
                                                :disabled="isSelected(fields.label)"
                                                :title="fields.label"
                                        >

                                            {{ fields.label }}
                                        </el-checkbox>
                                    </div>
                                </el-checkbox-group>
                            </div>
                        </el-tab-pane>
                        <!--                        自定义字段-->
                        <el-tab-pane label="自定义字段" name="second">
                            <div class="controlsBox">
                                <el-button type="primary" plain @click="dialogVisible = true">新增字段</el-button>
                                <el-button type="danger" plain @click="deleteBtn">批量删除</el-button>
                            </div>
                            <div>
                                <el-input
                                        placeholder="搜索内容"
                                        v-model="searchCustom"
                                />
                                <el-checkbox-group v-model="zdy_selectedNames">
                                    <div>
                                        <el-checkbox
                                                v-for="fields in zdy_filteredfields"
                                                :key="fields.key"
                                                :label="fields.label"
                                                :disabled="zdy_isSelected(fields.label)"
                                                :title="fields.label"
                                        >

                                            {{ fields.label }}
                                        </el-checkbox>
                                    </div>
                                </el-checkbox-group>
                            </div>
                        </el-tab-pane>
                    </el-tabs>
                </div>


                <!--                展示选中的字段-->
                <div class="rightBox">
                    <div>
                        <h5>已选系统字段</h5>
                        <div class="selectedBox">
                            <!--                            获取系统默认模板-->
                            <div v-for="(item,index) in sys_moren" :key="index">
                                <span style="color: #282828">{{item.label}}</span>
                            </div>
                            <div
                                    v-for="item in filteredSelected"
                                    :key="item.key"
                                    style="display: flex; align-items: center; margin-bottom: 5px;"
                            >
                                <span style="color: #282828">{{ item.label }}</span>
                                <p style="margin-left: 10px;font-size: 16px;cursor: pointer;color: #636C78"
                                   @click="removeFromSelected(item.label)">
                                    ×</p>
                            </div>
                        </div>
                        <!--                        已选自定义字段-->
                        <h5>已选自定义字段</h5>
                        <div class="selectedBox">

                            <div
                                    v-for="item in zdy_filteredSelected"
                                    :key="item.key"
                                    style="display: flex; align-items: center; margin-bottom: 5px;"
                            >
                                <span style="color: #282828">{{ item.label }}</span>
                                <p style="margin-left: 10px;font-size: 16px;cursor: pointer;color: #636C78"
                                   @click="zdy_removeFromSelected(item.label)">
                                    ×</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="demo-drawer__footer">
                <el-button @click="confirmBtn" type="primary">确 定</el-button>
                <el-button @click="cancelForm">取 消</el-button>
            </div>
        </el-drawer>
        <!--        新增字段-->
        <el-dialog
                title="新增字段"
                :visible.sync="dialogVisible"
                width="30%"
                :close-on-click-modal="false">
            <p style="margin: 10px">如需添加多个字段请用中文逗号分隔，比如：一，二，三</p>
            <el-form ref="form" :model="addForm" label-width="80px">
                <el-form-item label="字段名称">
                    <el-input v-model="addForm.name" placeholder="请输入字段名称" @input="handleInput"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="addFields">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import {
        addCustomFields,
        addTemplatePort,
        deleteCustomFields,
        getCustomTemplate,
        getSystemTemplate
    } from '../../api/templatePage';
    import bus from '../../components/common/bus';

    export default {
        name: 'addTemplate',
        data() {
            return {
                dialogVisible: false, //新增字段
                drawer: false,
                rules: {
                    id: [
                        { required: true, message: '请选择客户', trigger: 'change' }
                    ],
                    name: [
                        { required: true, message: '请输入模板名称', trigger: 'blur' }
                    ]
                },
                templateForm: {
                    id: '',
                    name: ''
                },
                form: {
                    type: []
                },
                sys_fei_moren: [],  //非默认字段
                selectedNames: [],  //左侧
                kehu_zidingyi: [],  //自定义字段
                zdy_selectedNames: [],  //自定义
                searchQuery: '',
                searchCustom: '',  //自定义字段
                sys_moren: [],  //系统默认模板
                activeName: 'first',
                addForm: {
                    name: ''
                }
            };
        },
        computed: {
            //系统默认左侧数据
            filteredfields() {
                return this.sys_fei_moren.filter(fields =>
                    fields.label.includes(this.searchQuery)
                );
            },
            //监听右侧非系统默认字段
            filteredSelected() {
                return this.sys_fei_moren.filter(fields =>
                    this.selectedNames.includes(fields.label)
                );
            },
            //左侧自定义数据
            zdy_filteredfields() {
                return this.kehu_zidingyi.filter(fields => {
                    return fields.label.includes(this.searchCustom);
                });
            },
            //监听右侧自定义字段
            zdy_filteredSelected: {
                get() {
                    const seenLabels = new Set();
                    return this.kehu_zidingyi
                        .filter(fields =>
                            this.zdy_selectedNames.includes(fields.label) &&
                            !seenLabels.has(fields.label) && // 检查是否已经存在
                            seenLabels.add(fields.label) // 添加到 Set 中
                        );
                }
                ,
                set(newSelected) {
                    this.zdy_selectedNames = newSelected.map(item => item.label);
                }
            }
        },
        methods: {
            //新增字段
            addBtn() {
                getSystemTemplate().then(res => {
                    if (res.code == 200) {
                        this.drawer = true;
                        this.sys_moren = res.data.sys_moren;
                        this.sys_fei_moren = res.data.sys_fei_moren;
                    } else {
                        this.$message.error(res.msg);
                    }
                });
            },
            handleClose() {
                if (this.drawer) {
                    return;
                }
            },
            //取消
            cancelForm() {
                this.drawer = false;
            },
            //确定
            confirmBtn() {
                this.drawer = false;
            },
            //是否禁用
            isSelected(name) {
                return this.selectedNames.includes(name);
            },
            //是否禁用
            zdy_isSelected(name) {
                return this.zdy_selectedNames.includes(name);
            },
            //删除当前数据 非默认
            removeFromSelected(name) {
                this.selectedNames = this.selectedNames.filter(selected => selected !== name);
            },
            //删除当前数据 自定义
            zdy_removeFromSelected(name) {
                this.zdy_selectedNames = this.zdy_selectedNames.filter(selected => selected !== name);
            },
            //切换tabs
            handleClick(tab) {
                if (tab.name == 'second') {
                    this.getCustom();
                }
            },
            //新增字段
            addFields() {
                if (this.addForm.name == '') {
                    this.$message.error('请输入内容');
                } else {
                    addCustomFields({ name: this.addForm.name }).then(res => {
                        if (res.code == 200) {
                            this.$message.success(res.msg);
                            this.dialogVisible = false;
                            this.addForm.name = '';
                            this.getCustom();
                        } else {
                            this.$message.error(res.msg);
                        }
                    });
                }
            },
            //获取自定义数据列表
            getCustom() {
                getCustomTemplate().then(res => {
                    if (res.code == 200) {
                        this.kehu_zidingyi = res.data.kehu_zidingyi;
                    } else {
                        this.$message.error(res.msg);
                    }
                });
            },
            //删除
            deleteBtn() {
                let arr = [];
                this.zdy_filteredSelected.forEach(res => {
                    arr.push(res.key);
                });
                if (arr.length == 0) {
                    this.$message.error('请选择要删除的数据');
                } else {
                    this.$confirm('请确认是否批量删除已选字段 ', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        deleteCustomFields({ key_arr: arr }).then(res => {
                            if (res.code == 200) {
                                this.$message.success(res.msg);
                                this.getCustom();
                            } else {
                                this.$message.error(res.msg);
                            }
                        });
                    }).catch(() => {

                    });
                }
            },
            //确认新增
            verifyAdd() {
                this.$refs.form.validate(valid => {
                    if (valid) {
                        let obj = {
                            name: this.templateForm.name,
                            sys_fei_field: this.filteredSelected,
                            kehu_field: this.zdy_filteredSelected
                        };
                        addTemplatePort(obj).then(res => {
                            if (res.code == 200) {
                                this.$message.success(res.msg);
                                bus.$emit('close_current_tags');
                                this.$router.push({ path: '/templatePage' });
                            } else {
                                this.$message.error(res.msg);
                            }
                        });
                    } else {
                        return false;
                    }
                });
            },
            handleInput(value) {
                // 将英文逗号替换为中文逗号
                const fixedValue = value.replace(/,/g, '，');
                this.addForm.name = fixedValue; // 更新输入框内容
            }
        },
        created() {

        }
    };
</script>

<style scoped lang="less">

    .addBox {
        padding: 30px;
        background-color: #ffffff;
        border-radius: 5px;
    }

    /deep/ .el-drawer__body {
        padding: 30px;
    }

    .bigBox {
        display: flex;
        height: 90vh;
    }

    .leftBox, .rightBox {
        width: 50%;
        max-height: 90vh;
        overflow-y: auto;
    }

    .leftBox {
        box-shadow: 4px 0 6px #0000000d;

        div {
            margin-top: 10px;

            .el-input {
                width: 90%;
            }
        }
    }

    .leftBox::-webkit-scrollbar {
        /*滚动条整体样式*/
        width: 7px; /*高宽分别对应横竖滚动条的尺寸*/
        height: 1px;
    }

    .leftBox::-webkit-scrollbar-thumb {
        /*滚动条里面小方块*/
        border-radius: 10px;
        height: 20px;
        -webkit-box-shadow: inset 0 0 5px #DBDDE0;
        background: #DBDDE0;
    }

    .leftBox::-webkit-scrollbar-track {
        /*滚动条里面轨道*/
        -webkit-box-shadow: inset 0 0 5px #EBECED;
        border-radius: 10px;
        background: #ffffff;
    }

    .rightBox::-webkit-scrollbar {
        /*滚动条整体样式*/
        width: 7px; /*高宽分别对应横竖滚动条的尺寸*/
        height: 1px;
    }

    .rightBox::-webkit-scrollbar-thumb {
        /*滚动条里面小方块*/
        border-radius: 10px;
        height: 20px;
        -webkit-box-shadow: inset 0 0 5px #DBDDE0;
        background: #DBDDE0;
    }

    .rightBox::-webkit-scrollbar-track {
        /*滚动条里面轨道*/
        -webkit-box-shadow: inset 0 0 5px #EBECED;
        border-radius: 10px;
        background: #ffffff;
    }

    .demo-drawer__footer {
        position: fixed;
        bottom: 20px;
    }

    .rightBox {

        div {
            padding: 10px;
        }

    }

    .addTo {
        margin: 10px;
    }

    .title {
        display: flex;
        flex-direction: row-reverse;
    }

    .el-checkbox {
        padding: 5px;
        width: 140px;
        border: 1px solid #DCDEE2;
        border-radius: 5px;
        margin: 5px;

        /deep/ .el-checkbox__label {
            display: inline-block;
            vertical-align: middle; /* 调整对齐方式 */
            width: 110px;
            white-space: nowrap; /* 不换行 */
            overflow: hidden; /* 超出隐藏 */
            text-overflow: ellipsis; /* 省略号 */
        }
    }


    .selectedBox {
        width: 100%;
        display: flex;
        flex-wrap: wrap;

        div {
            font-size: 14px;
            background-color: #F2F4F7;
            border-radius: 5px;
            margin: 5px;
        }
    }

    /deep/ .el-dialog__body {
        padding: 20px;
    }

    /deep/ .el-tabs__item.is-active {
        color: #D05953;
    }

    /deep/ .el-tabs__active-bar {
        background-color: #D05953;
    }

    /deep/ .el-tabs__item:hover {
        color: #D05953;
    }
</style>
